var map = {
	"./SAD-1.jpg": "IQLH",
	"./SAD-2.jpg": "BYvh",
	"./SAD-3.jpg": "1Of6",
	"./SAD-4.jpg": "qxOC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NJhg";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/SAD\-.*\.jpg$
// module id = NJhg
// module chunks = 0